<template>
  <div>
    <div v-if="isAdset">
      <div v-if="!isEditing">
        ${{ parseFloat(params.data.max_bid_price).toFixed(3) }}
       <vs-icon
          id="insights-table-bid-edit-button"
          v-if="!isEditing && this.$canAny('edit_personal_campaigns', 'edit_all_campaigns')"
          class="ml-1 cursor-pointer"
          @click="isEditing = true"
          style="font-size: 15px !important;"
          icon="speakol-edit"
          icon-pack="speakol"
        ></vs-icon>
      </div>
      <div class="flex py-2" v-else>
        <vx-input-group>
          <template slot="prepend">
            <div class="prepend-text dollar-sign dollar-sign-adset">
              <span>$</span>
            </div>
          </template>
          <div class="vx-input-group-default flex-grow">
            <div
              class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
            >
              <div class="vs-con-input">
                <input
                  id="insights-table-bid-input"
                  min="0"
                  class="vs-inputx vs-input--input vs-input-adset"
                  type="number"
                  @input="setNewBid($event)"
                  :value="newbid"
                />
              </div>
              <span></span>
            </div>
          </div>
        </vx-input-group>
        <vs-icon
          id="insights-table-bid-save-button"
          class="save-new-cpm pt-4 mx-2"
          @click="triggerUpdateBid()"
          icon="speakol-save"
          icon-pack="speakol"
        ></vs-icon>
        <vs-icon
          id="insights-table-bid-cancel-button"
          class="cancel-new-cpm pt-4"
          @click="resetBid()"
          icon="speakol-cancel"
          icon-pack="speakol"
        ></vs-icon>
      </div>

      <vs-popup class="holamundo" :active.sync="showBiddingPopup">
        <PriceFloorTable
          v-model="customBids"
          :adsetIndex="0"
          :cost_per_action="newbid"
          :domains="domains"
          :action="cost_type_map[this.params.data.cost_type_id]"
          :bid_type="bidType.short.toUpperCase()"
          :cancel="hideBiddingPopup"
          :popupActive="showBiddingPopup"
          :isEditing="true"
          @confirm="priceFloorChecked"
        />
      </vs-popup>
    </div>
    <div v-else></div>
  </div>
</template>

<script>
// import BiddingPopup from '@/components/popups/bidding_confirmation_popup/index.vue'
import biddingTypes from '@/views/campaigns/biddingTypes.js'

import PriceFloorTable from '@/views/campaigns/components/steps/components/BudgetContent/components/PriceFloorTable.vue'

export default {
  components: {
    // BiddingPopup,
    PriceFloorTable
  },
  data () {
    return {
      isEditing: true,
      newbid: null,
      showBiddingPopup: false,
      domains: [],
      customBids: [],
      cost_type_map: {
        1: 'impressions',
        2: 'clicks',
        3: 'videos',
        4: 'actions'
      }
    }
  },
  computed: {
    isAdset () {
      return 'campaign' in this.params.data
    },
    bidType () {
      const optimizingFor = this.cost_type_map[this.params.data.cost_type_id]

      return biddingTypes[optimizingFor] || {}
    }
  },
  beforeMount () {
    if (!this.isAdset) {
      return
    }

    this.updateCustomBids(this.params.data.custom_bids)

    this.newbid = this.params.data.max_bid_price
    this.isEditing = false
  },
  methods: {
    updateCustomBids (custom_bids) {
      this.customBids = custom_bids.map(bid => {
        return {
          id: bid.id,
          bid: bid.pivot.max_bid
        }
      })
    },
    hideBiddingPopup () {
      this.showBiddingPopup = false
    },
    setNewBid (e) {
      // validate and format the cost_per_action value
      const value = parseFloat(e.target.value)

      if (Number.isNaN(value)) {
        this.newbid = null
        return
      }

      if (value < 0) {
        return
      }

      if (value > 9999.999) {
        this.params.context.parent.stateModal = {
          type: 'error',
          show: true,
          body: 'The value should be less than  9999.999'
        }
        // this.newbid = 9999.999
        return
      }

      const fraction = value.toString().split('.')[1] || ''

      if (fraction.length > 3) {
        this.params.context.parent.stateModal = {
          type: 'error',
          show: true,
          body: 'The Decimals should be up to 3 digits'
        }
        this.newbid = value.toFixed(3)
        return
      }

      this.newbid = value
    },
    triggerUpdateBid () {
      const budget = this.params.data.budget !== 0 ? this.params.data.budget : this.params.data.daily_budget
      if (this.newbid >= budget) {
        this.params.context.parent.stateModal = {
          type: 'error',
          show: true,
          body: 'Bid can not be bigger than or equal the budget value'
        }
      } else {
        this.updateAdsetBid()
      }
    },
    async updateAdsetBid () {
      try {
        const response = await window.axios.post('/campaigns/get/adset/domain/price/floor', {
          adset_id: this.params.data.id,
          bid: this.newbid
        })

        if (!response.data.payload.passes) {
          this.updateCustomBids(
            // transform the data to match the required format for the PriceFloorTable
            response.data.payload.domains.map(domain => {
              return {
                id: domain.id,
                pivot: {
                  max_bid: domain.minbid
                }
              }
            })
          )

          this.domains = response.data.payload.domains
          this.showBiddingPopup = true
          return
        }

        await this.priceFloorChecked()
      } catch (error) {
        this.params.context.parent.stateModal = {
          type: 'error',
          show: true,
          body: error.response.data.errors.bid.join(', ')
        }
      }
    },
    resetBid () {
      this.newbid = this.params.data.max_bid_price
      this.isEditing = false
    },
    async priceFloorChecked () {
      const form = {
        adset_id: this.params.data.id,
        bid: this.newbid,
        custom_bids: this.customBids,
        detachable_domains : this.domains.filter(
          i => this.customBids.findIndex(v => v.id === i.id) === -1
        ).map(i => i.id)
      }

      await window.axios.post('/campaigns/update/adset/bid', form)

      this.isEditing = false

      // set the new bid
      this.params.node.setData({
        ...this.params.node.data,
        custom_bids: this.customBids.map(cbid => {
          return {
            id: cbid.id,
            pivot: {
              max_bid: cbid.bid
            }
          }
        }),
        max_bid_price: this.newbid
      })

      this.$nextTick(() => {
        this.params.api.refreshCells({
          rowNodes: [this.params.node],
          force: true
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dollar-sign-adset {
  margin-top: 0;
  height: 40px;
}

.vs-input-adset {
  height: 40px;
}
</style>
